import React, { useCallback } from "react"
import * as AppConstants from "../../../../../utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"


function TabRicaviCompensi(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_RICAVI_DICHIARATI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.ricCompDic
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricCompDic
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.ricCompDic
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_RICAVI_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.ricCompSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricCompSti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.ricCompSti
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_RICAVI_ADDETTO_DICHIARATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.ricCompAddDic
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.ricCompAddDic
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.ricCompAddDic
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_RICAVI_ADDETTO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.ricCompAddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.ricCompAddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.ricCompAddSti
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
        </React.Fragment>
    )
}
export default TabRicaviCompensi
